module.exports = __webpack_public_path__ + "static/media/S (142).c184bf6b.jpg";